module.exports = __webpack_public_path__ + "img/mobile-screen-button-solid.8c97a9a4.svg";